import { useState } from "react";
import styled from "styled-components";
import { InputTextarea, ModalForm, Text } from "@ficatranquilo/contabilidade.com-ui";

/** Mesmo limite do back (POST /project-hours/approve-hours). */
export const REJECTION_REASON_MAX_LENGTH = 500;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

/**
 * Reprovação de horas com motivo: na aprovação de horas e na aba Horas.
 *
 * O back aceita reprovar sem motivo (o front antigo não manda), mas aqui ele é
 * obrigatório: o prestador vê o texto na linha reprovada.
 *
 * Props:
 * - title: título do modal ("Reprovar 3 lançamentos")
 * - summary: { text, replaces } do `Text` da lib com o resumo; texto digitado já escapado
 * - loading: chamada em andamento (trava o modal)
 * - onConfirm(reason): recebe o motivo sem espaços nas pontas
 * - onClose
 * - idForm, description, maxLength: opcionais, para outro registro com motivo
 *   (o ajuste de ponto passa "O colaborador vê este texto." e sem limite, como o back)
 */
export default function RejectHoursModal({
  title,
  summary,
  loading,
  onConfirm,
  onClose,
  idForm = "hours-rejection-reason",
  description = "O prestador vê este texto.",
  maxLength = REJECTION_REASON_MAX_LENGTH,
}) {
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");

  function close() {
    if (!loading) onClose();
  }

  function confirm() {
    const text = reason.trim();
    if (!text) {
      setError("Informe o motivo.");
      return;
    }
    onConfirm(text);
  }

  return (
    <ModalForm
      $showModal
      $setShowModal={close}
      $noClose={loading}
      $isLoading={loading}
      $size="medium"
      $title={title}
      $contentBackground="N0"
      $actions={[
        { text: "Cancelar", action: close, variant: "outline", isDisabled: loading },
        { text: "Reprovar", action: confirm, variant: "danger", isDisabled: loading },
      ]}>
      <Content>
        {summary ? (
          <Text
            $text={summary.text}
            $replaces={summary.replaces}
            $variant="paragraph_small_medium"
            $color="N700"
            $colorEmphasis="N900"
          />
        ) : null}
        <InputTextarea
          $idForm={idForm}
          $label="Motivo da reprovação"
          $variant="default"
          $isRequired
          $errors={error}
          $description={description}
          maxLength={maxLength || undefined}
          rows={3}
          value={reason}
          onChange={(e) => {
            setReason(e.target.value);
            if (error) setError("");
          }}
        />
      </Content>
    </ModalForm>
  );
}
